import { PropsWithChildren } from "react";
import { cn } from "../../../utils/classes";
import styles from "./secondary-header.module.css";

export type SecondaryHeaderProps = PropsWithChildren<{
  className?: string;
}>;

/**
 * The page-level secondary header: a thin, consistent container for the
 * current page's own buttons/filters. Intentionally has no opinion about
 * what goes inside it beyond the container itself.
 */
export function SecondaryHeader({
  children,
  className,
}: SecondaryHeaderProps) {
  return <div className={cn(styles.bar, className)}>{children}</div>;
}
